import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Cart() {
  const navigate = useNavigate();
  const [cartItems, setCartItems] = useState([
    { id: 1, name: 'أرز بسمتي هندي - 5 كجم', price: 45, quantity: 2, image: 'https://public.readdy.ai/ai/img_res/6a8fdf63edd9f7831323d41ef472c53c.jpg', provider: 'بقالة الخير' },
    { id: 2, name: 'زيت زيتون بكر - 1 لتر', price: 89, quantity: 1, image: 'https://readdy.ai/api/search-image?query=extra%20virgin%20olive%20oil%20bottle%2C%20professional%20product%20photography%2C%20clean%20white%20background%2C%20high%20quality%20commercial%20photo&width=100&height=100&seq=c2&orientation=squarish', provider: 'بقالة الخير' },
    { id: 3, name: 'حليب طازج - 2 لتر', price: 18, quantity: 3, image: 'https://readdy.ai/api/search-image?query=fresh%20milk%20carton%2C%20professional%20product%20photography%2C%20clean%20white%20background%2C%20high%20quality%20commercial%20photo&width=100&height=100&seq=c3&orientation=squarish', provider: 'متجر الطازج' }
  ]);

  const [deliveryTime, setDeliveryTime] = useState('immediate');

  const updateQuantity = (id: number, newQuantity: number) => {
    if (newQuantity === 0) {
      setCartItems(cartItems.filter(item => item.id !== id));
    } else {
      setCartItems(cartItems.map(item => 
        item.id === id ? { ...item, quantity: newQuantity } : item
      ));
    }
  };

  const subtotal = cartItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  const deliveryFee = 15;
  const total = subtotal + deliveryFee;

  if (cartItems.length === 0) {
    return (
      <div className="min-h-screen bg-[#F6F6F6] flex flex-col" style={{ fontFamily: 'Cairo, sans-serif' }}>
        <div className="fixed top-0 left-0 right-0 bg-white z-50 shadow-sm">
          <div className="px-4 py-4 flex items-center gap-3">
            <button onClick={() => navigate('/home')} className="w-10 h-10 flex items-center justify-center">
              <i className="ri-arrow-right-line text-[#212121] text-2xl"></i>
            </button>
            <h1 className="text-[#212121] text-lg font-bold">السلة</h1>
          </div>
        </div>

        <div className="flex-1 flex flex-col items-center justify-center px-6 pt-16">
          <div className="w-32 h-32 bg-gray-100 rounded-full flex items-center justify-center mb-6">
            <i className="ri-shopping-cart-line text-gray-300 text-6xl"></i>
          </div>
          <h2 className="text-[#212121] text-xl font-bold mb-2">السلة فارغة</h2>
          <p className="text-gray-500 text-sm text-center mb-8">ابدأ بإضافة منتجات إلى سلتك</p>
          <button
            onClick={() => navigate('/products')}
            className="bg-gradient-to-r from-[#0D47A1] to-[#1976D2] text-white px-8 py-3 rounded-xl font-bold shadow-lg active:scale-95 transition-transform"
          >
            تصفح المنتجات
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#F6F6F6] pb-32" style={{ fontFamily: 'Cairo, sans-serif' }}>
      {/* Top Navigation */}
      <div className="fixed top-0 left-0 right-0 bg-white z-50 shadow-sm">
        <div className="px-4 py-4 flex items-center gap-3">
          <button onClick={() => navigate('/home')} className="w-10 h-10 flex items-center justify-center">
            <i className="ri-arrow-right-line text-[#212121] text-2xl"></i>
          </button>
          <h1 className="text-[#212121] text-lg font-bold flex-1">السلة</h1>
          <span className="text-[#0D47A1] text-sm font-medium">{cartItems.length} منتج</span>
        </div>
      </div>

      {/* Content */}
      <div className="pt-20 px-4">
        {/* Cart Items */}
        <div className="space-y-3 mb-4">
          {cartItems.map((item) => (
            <div key={item.id} className="bg-white rounded-2xl p-4">
              <div className="flex gap-3 mb-3">
                <div className="w-20 h-20 bg-gray-100 rounded-xl overflow-hidden flex-shrink-0">
                  <img src={item.image} alt={item.name} className="w-full h-full object-cover" />
                </div>
                <div className="flex-1">
                  <h3 className="text-[#212121] font-bold text-sm mb-1 line-clamp-2">{item.name}</h3>
                  <p className="text-gray-500 text-xs mb-2">{item.provider}</p>
                  <span className="text-[#0D47A1] text-lg font-bold">{item.price} ر.س</span>
                </div>
                <button
                  onClick={() => updateQuantity(item.id, 0)}
                  className="w-8 h-8 flex items-center justify-center"
                >
                  <i className="ri-delete-bin-line text-gray-400 text-xl"></i>
                </button>
              </div>

              {/* Quantity Controls */}
              <div className="flex items-center justify-between">
                <div className="flex items-center bg-[#F6F6F6] rounded-xl">
                  <button
                    onClick={() => updateQuantity(item.id, item.quantity - 1)}
                    className="w-10 h-10 flex items-center justify-center"
                  >
                    <i className="ri-subtract-line text-[#212121]"></i>
                  </button>
                  <span className="w-12 text-center font-bold text-[#212121]">{item.quantity}</span>
                  <button
                    onClick={() => updateQuantity(item.id, item.quantity + 1)}
                    className="w-10 h-10 flex items-center justify-center"
                  >
                    <i className="ri-add-line text-[#212121]"></i>
                  </button>
                </div>
                <span className="text-[#212121] font-bold">{item.price * item.quantity} ر.س</span>
              </div>
            </div>
          ))}
        </div>

        {/* Delivery Time */}
        <div className="bg-white rounded-2xl p-5 mb-4">
          <h3 className="text-[#212121] font-bold mb-4">وقت التوصيل</h3>
          <div className="grid grid-cols-2 gap-3">
            <button
              onClick={() => setDeliveryTime('immediate')}
              className={`py-4 rounded-xl font-medium transition-all ${
                deliveryTime === 'immediate'
                  ? 'bg-[#0D47A1] text-white shadow-lg'
                  : 'bg-[#F6F6F6] text-gray-600'
              }`}
            >
              <i className="ri-flashlight-fill text-xl mb-1 block"></i>
              فوري (30-45 دقيقة)
            </button>
            <button
              onClick={() => setDeliveryTime('scheduled')}
              className={`py-4 rounded-xl font-medium transition-all ${
                deliveryTime === 'scheduled'
                  ? 'bg-[#0D47A1] text-white shadow-lg'
                  : 'bg-[#F6F6F6] text-gray-600'
              }`}
            >
              <i className="ri-calendar-line text-xl mb-1 block"></i>
              مجدول
            </button>
          </div>
        </div>

        {/* Price Summary */}
        <div className="bg-white rounded-2xl p-5">
          <h3 className="text-[#212121] font-bold mb-4">ملخص الطلب</h3>
          <div className="space-y-3 mb-4">
            <div className="flex items-center justify-between text-sm">
              <span className="text-gray-600">المجموع الفرعي</span>
              <span className="text-[#212121] font-bold">{subtotal} ر.س</span>
            </div>
            <div className="flex items-center justify-between text-sm">
              <span className="text-gray-600">رسوم التوصيل</span>
              <span className="text-[#212121] font-bold">{deliveryFee} ر.س</span>
            </div>
            <div className="border-t border-gray-200 pt-3 flex items-center justify-between">
              <span className="text-[#212121] font-bold text-lg">الإجمالي</span>
              <span className="text-[#0D47A1] font-bold text-2xl">{total} ر.س</span>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4 z-50">
        <button
          onClick={() => navigate('/address')}
          className="w-full bg-gradient-to-r from-[#0D47A1] to-[#1976D2] text-white py-4 rounded-xl font-bold text-lg shadow-lg active:scale-95 transition-transform"
        >
          تأكيد الطلب - {total} ر.س
        </button>
      </div>
    </div>
  );
}